/*函数节流*/
export function throttle(fn, interval) {
  var enterTime = 0
  var gapTime = interval || 300
  return function () {
    var context = this
    var backTime = new Date()
    if (backTime - enterTime > gapTime) {
      fn.call(context, arguments)
      enterTime = backTime
    }
  }
}

/*函数防抖*/
export function debounce(fn, interval) {
  var timer
  var gapTime = interval || 1000
  return function () {
    clearTimeout(timer)
    var context = this
    var args = arguments
    timer = setTimeout(function () {
      fn.call(context, args)
    }, gapTime)
  }
}

export function checkPlatform() {
  if (/(iPhone|iPad|iPod|iOS|Mac OS)/i.test(navigator.userAgent)) {
    return 'iOS'
  } else if (/(Android)/i.test(navigator.userAgent)) {
    return 'Android'
  } else {
    return 'PC'
  }
}

export function pwToPx(vw) {
  // 获取当前视口的宽度
  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  // 将 vw 值转换为 px 值
  // 返回转换后的 px 值
  return vw * (viewportWidth / 100)
}

/// 判断是否在微信浏览器内
export function checkIsWeixin() {
  const ua = navigator.userAgent.toLowerCase()
  const isWXWork = ua.match(/wxwork/i) == 'wxwork'

  const isWeixin = !isWXWork && ua.match(/MicroMessenger/i) == 'micromessenger'

  return isWeixin
}
